/*
 * jQuery zoomSwap
 * Developed by Mike Avello
 *
 * Version 0.9.0 Beta
 * Updated 10/18/2011
 *
 */
(function($) {

	function debug(s) {
		if ($.fn.zoomSwap.debug) {
			log(s);
		};
	};	
	function log() {
		if (window.console && console.log) {
			console.log('zoomSwap: ' + Array.prototype.join.call(arguments,' '));
		};
	};

	$.fn.zoomSwap = function(settings) {
		/*===============================
		
		trigger: null,			// selector for enabling zoom mode, in the case of multiple steps this is to zoom in. default is to run on hover.
		reset: null,			// selector for resetting zoom. default is to run on mouse leave.
		out: null,				// selector for zooming out.
		loader: null,			// plain text or an image tag eg.: "<img src='/assets/images/spinner.gif' />"
		rotateBack: null,		// selector for allowing multiple image rotation from supplied array in reverse
		rotateNext: null,		// selector for allowing multiple image rotation from supplied array
		zoomSteps: null,	    // optional setting for number of zoomed steps between regular and full zoom.
		zoomMethod: 'hover',	// setting to 'hover' allows zoom motion to run on hover. default is click and drag.
		zoomInverse: false,		// sets zoom motion direction. setting to 'true' enables inverse direction.
		cursor: 'move',			// css setting for cursor when zoomed. default is 'move'
		rPath: null,			// folder path for regular image. default is 'regular'
		zPath: null,			// folder path for zoom image. default is 'zoom'
		autoSwap: false,		// sets auto play for images in array. Default is false
		swapTimeout: '100',		// sets timeout for use during auto play set up
		swapDelay: '10',		// sets initial delay prior to start of auto play
		
		=================================*/
		
	
		return this.each(function() {
			var $target = $(this);
			var opts = optionsHandler($target, settings);
		});
	};
	
	
	// configures options and settings for plugin
	function optionsHandler($target, settings) {
		if (settings === undefined || settings === null) {
			settings = {};
		};
	
		if (settings.constructor == String) {		
			switch(settings) {
				case 'reset':
					settings = $target.data('zoomSwap.opts');
					destroyZoom($target, settings);
					return false;
				case 'play':
					settings = $target.data('zoomSwap.opts');
					clearTimeout(settings.autoTimeout);
					swap($target, settings, -1, 0);
					return false;
				case 'stop':
					settings = $target.data('zoomSwap.opts');
					clearTimeout(settings.autoTimeout);
					swap($target, settings, 0, 1);
					return false;
				case 'reload':
					// reloads images from markup to array
					settings = $target.data('zoomSwap.opts');
					settings.imgArray = $target.data().zoomswap;
					return false;
				default:
			};
			return settings;
		}	
		
		else if (settings.constructor === Number) {
			var num = settings;
			settings = $target.data('zoomSwap.opts');
			settings.autoSwap = false;
			swap($target, settings, num, 1);
		}
		
		else if (settings.constructor != Number && settings.constructor != String) {
			if (!settings.imgArray) {
				// gets array of images from data-imgarray attribute
				settings.imgArray = $target.data().zoomswap;
				//settings.imgArray = imgArray;
			};
	
		
			var cache = [];
			//$.preLoadImages = function() {
				var arrayLength = settings.imgArray.length;
				for (var i = arrayLength; i--;) {
					var cacheImage = document.createElement('img');
					cacheImage.src = settings.imgArray[i];
					cache.push(cacheImage);
				}
				
				for (var i = arrayLength; i--;) {
					var cacheImage = document.createElement('img');
					cacheImage.src = settings.imgArray[i].replace(settings.rPath, settings.zPath);
					cache.push(cacheImage);
				}
			//}
		}
		
		settings.targetSize = [$target.width(), $target.height()];
	
		$target[($.fn.hoverIntent && !settings.disableHI) ? 'hoverIntent' : 'hover'](targetOver,targetOut);
        $target.attr("style", "-ms-touch-action: none;")
        
		function targetOver(){return enableZoom($target, settings)};
		function targetOut(){return destroyZoom($target, settings)};	
			//.bind('mouseenter', function() {return enableZoom($target, settings)})
			//.bind('mouseleave', function() {return destroyZoom($target, settings)});
		
		if (settings.trigger){
			$target.unbind('mouseenter');
			$(settings.trigger).bind('click', function(event) {event.preventDefault(); return enableZoom($target, settings)});
		};
		
		if (settings.out){
			$target.unbind('mouseleave');
			$(settings.out).bind('click', function(event) {event.preventDefault(); return enableZoom($target, settings, true)});
		};

		if (settings.reset){
			$target.unbind('mouseleave');
			$(settings.reset).bind('click', function(event) {event.preventDefault(); return destroyZoom($target, settings)});
		};

		if (settings.loader){
			$target.append("<span class='loader'>"+settings.loader+"<\/span>");
			var loaderWrapper = $target.find('.loader');
			loaderWrapper.css({left: ($target.width() - loaderWrapper.width()) / 2, top: ($target.height() - loaderWrapper.height()) / 2});
		};

		if (settings.rotateNext)
			createRotation($target, settings)
			
		if (!settings.cursor)
			settings.cursor = 'move';
		
		if (!settings.rPath)
			settings.rPath = 'regular';
		
		if (!settings.zPath)
			settings.zPath = 'zoom';
		
		if (settings.zoomSteps)
			settings.curStep = 0;
		
		var startTime = settings.autoSwap ? 10 : false;
		
		if (!settings.curPos) {
			settings.curPos = 0;
		};
		
		// if it's an auto swap, start the process
		if (startTime) {
			startTime += (settings.swapDelay || 0);
			if (startTime < 10)
				startTime = 10;
			settings.autoTimeout = setTimeout( function(){
				//go(els,opts2,0,!opts.backwards);
				swap($target, settings, settings.curPos -1, 0);
			}, startTime);
		};
		
		$target.data('zoomSwap.opts', settings);	
	};
	
	//function that activates the zoom feature
	function enableZoom($target, settings, reverse) {
        // check target size in case dimensions changed
        settings.targetSize = [$target.width(), $target.height()];
        
		if ($target.find('.zoomImage').length == 1 && settings.zoomSteps == undefined) return;


		if (settings.zoomSteps != undefined && settings.curStep == settings.zoomSteps && reverse != true){			
			return;
		} else if (reverse == true) {
			if (settings.curStep == 1 || settings.curStep == 0) {
				destroyZoom($target, settings)
				return;
			} else {
				settings.curStep = settings.curStep - 1;
			};
		} else {
			settings.curStep = settings.curStep + 1;
		};
		
		
		var tSize = settings.targetSize,
		    tOffset = $target.offset(),
		    regImage = $target.find('img:first'),
		    curStep = (settings.zoomSteps == undefined) ? '' : settings.curStep;
		    zoomSrc = regImage.attr("src").replace(settings.rPath, settings.zPath+curStep);
		    		    
		regImage.css({position:'relative', zIndex: '5'});
		$target.children("span.loader").show();
	
		var alttxt = "";
		if(settings.zoomMethod != 'hover')
			alttxt = "Click &amp; Drag";
			
		
		$target.append('<img class="zoomImage" src='+zoomSrc+' style="display:none; position:absolute; z-index:10;" title="'+alttxt+'" alt="'+alttxt+'" />').css({position: "relative", overflow: "hidden"});
		
		var zImage = $target.find('.zoomImage:last').attr('style', function(i,s) { return s + 'max-width: none !important;' });
		
		//sets up image properties after image is finished loading
		zImage.load(function () {			
			$target.children("span.loader").hide();
			var zSize = [zImage.width(), zImage.height()];
			var iXPos = (tSize[0] - zSize[0]) / 2;
			var iYPos = (tSize[1] - zSize[1]) / 2;
            			
			$(this).css({ width: zSize[0], height: zSize[1], left: iXPos, top: iYPos}).fadeIn(function(){
				zImage.prev('.zoomImage').fadeOut().remove();
			});
			
			if ($target.data('zoomEnabled') == true){
				zImage.stop(true, true);
			};
			
			zoomMotion($target, settings, zImage, tSize, zSize, tOffset);
		}).error(function (){
			alert("Image does not exist or its SRC is not correct.");
		});
                
	};

	// function that handles the panning of zoomed image
	function zoomMotion($target, settings, zImage, tSize, zSize, tOffset){
		
		// sets up additional settings based on zoom trigger method specified
		var zMethod = 'mousedown';
		if(settings.zoomMethod=='hover'){
            if(window.PointerEvent) {
                zMethod = 'pointermove';
                $target[0].addEventListener("pointermove", handleMovement, true);
            } else if (window.MSPointerEvent) {
                zMethod = 'MSPointerMove';
                $target[0].addEventListener("MSPointerMove", handleMovement, true);
            } else {
                zMethod = 'mousemove';
                $target[0].addEventListener("mousemove", handleMovement, true);
                $target[0].addEventListener("touchmove", handleMovement, true);
            }
            
            debug(zMethod);
            
			$target.on('mousedown', function(e){
				e.preventDefault();	
			});
		};	

		// binds the function trigger based on the zoom trigger method
		function handleMovement(e){

			// binds panning to mousemove event
			// removing this will prevent ability to pan zoomed image
			var zpos=[parseInt(zImage.css('left'),10), parseInt(zImage.css('top'),10)];
			var xypos=[e.pageX, e.pageY];
            var pos=zpos;
            var panX=e.pageX-xypos[0];
            var panY=e.pageY-xypos[1];
            var pan={h: (tSize[0] > zSize[0])? false:true, v:(tSize[1] > zSize[1])? false:true};

            if(settings.zoomInverse==true){
                var leftPan = (e.pageX - tOffset.left) * (tSize[0] - zSize[0]) / (tSize[0]);
                var topPan = (e.pageY - tOffset.top) * (tSize[1] - zSize[1]) / (tSize[1]);
                zImage.css({left: leftPan, top: topPan});
            } else if ((!settings.zoomInverse || settings.zoomInverse==false) && settings.zoomMethod=='hover'){
                var leftPan = (tSize[0] - (e.pageX - tOffset.left)) * (tSize[0] - zSize[0]) / (tSize[0]);
                var topPan = (tSize[1] - (e.pageY - tOffset.top)) * (tSize[1] - zSize[1]) / (tSize[1]);
                zImage.css({left: leftPan, top: topPan});
            } else {
                if (pan.h==true)
                    var leftPan=(panX > 0)? Math.min(0, pos[0] + panX) : Math.max(-zSize[0] + tSize[0], pos[0] + panX);
                if (pan.v==true)
                    var topPan=(panY > 0)? Math.min(0, pos[1] + panY) : Math.max(-zSize[1] + tSize[1], pos[1] + panY);

                zImage.css({left:(typeof leftPan!="undefined")? leftPan : pos[0], top:(typeof topPan!="undefined")? topPan : pos[1]})
            };
		};
        
        $target.css({cursor: settings.cursor});

        /*
		$target.mouseup(function(e){
			e.preventDefault();
			if (settings.zoomMethod!='hover')
				$target.unbind('mousemove');
		}).mouseleave(function(e){
			e.preventDefault();
			$target.unbind('mousemove');
		});
        */
	};
	
	// this function clears up the zoomed image and settings
	// unbinds events
	function destroyZoom($target, settings){
		if (settings.zoomSteps)
			settings.curStep = 0;
	
		$target
			.data('zoomEnabled', false)
			.unbind('mousemove')
			.css({cursor: 'default'})
			.find('.zoomImage')
			.fadeOut(function(){
				$(this).remove();
			});
	};
	
	// image engine that handles the swapping of images and timeline management
	function swap($target, settings, num, manual){
		// don't begin another timeout-based transition if there is one active
		if (settings.busy) {
			debug('transition active, ignoring new tx request');
			return;
		}
		
		settings.busy = 1;
		
		// prep the after callacks
		// TODO: future callback support
		var after = function() {
			// tests to see if auto play is enabled
			if (manual == 0) {
				// runs through set of images in an array
				settings.curPos = num + 1;
				num = settings.curPos;
				if ( num < settings.imgArray.length ) {
					settings.autoTimeout = setTimeout( function(){
						swap($target, settings, settings.curPos, 0);
					}, (settings.swapTimeout || 150) );
				};
			};
		
			settings.busy = 0;
		};
		
		$.fn.zoomSwap.swap($target, settings, num, manual, after);		
	};
	
	// binding to trigger image rotation for trigger based setups
	function createRotation($target, settings){
		var img = $target.find('img.mainImage');
		var arrayPos = 0;
		var rotateLeft = $target.parent().find(settings.rotateBack);
		var rotateRight = $target.parent().find(settings.rotateNext);
		
		//right rotation click
		rotateRight.click(function(event){
			event.preventDefault();
			if (arrayPos >= (settings.imgArray.length - 1)){ arrayPos = 0; } 
			else { arrayPos = arrayPos + 1; };
			swap($target, settings, arrayPos, 1);			
		});
		
		//left rotation click
		rotateLeft.click(function(event){
			event.preventDefault();
			if (arrayPos == 0){ arrayPos = settings.imgArray.length-1; } 
			else { arrayPos = arrayPos - 1; };
			swap($target, settings, arrayPos, 1);
		});
	};
	
	$.fn.zoomSwap.swap = function($target, settings, num, manual, callback) {
		var img = $target.find('img.mainImage');
		img.attr('src', settings.imgArray[num]);
		
		if (img.siblings('.zoomImage').length == 1) {
			var zoomReplace = settings.imgArray[num].replace(settings.rPath, settings.zPath)				
			img.siblings('.zoomImage').attr('src', zoomReplace);
		};
		
		callback();
	};
})(jQuery);
define("plugins/jquery.zoomswap", ["jquery"], function(){});

